import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";

export function useFetchStaticPage() {
  const { slug } = useParams();

  return useQuery({
    queryKey: ["staticPage", slug],
    queryFn: async function () {
      if (!slug) throw new Error("No slug provided");

      return await apiRequest(`/api/get-article/${slug}/`, "GET", null, false);
    },
    retry: false,
  });
}
